import { useEffect, useRef } from 'react';
import { useCurrentModule } from '../ModuleProvider';
export const getBase44VoucherCardSelector = productId => `[data-hook="base44-voucher-card-${productId}"]`;
export const useBase44VoucherExposedBiEvent = productId => {
  const module = useCurrentModule();
  const hasFiredRef = useRef(false);
  useEffect(() => {
    if (hasFiredRef.current) {
      return;
    }
    const element = document.querySelector(getBase44VoucherCardSelector(productId));
    if (!element) {
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (!hasFiredRef.current && entries.some(entry => entry.isIntersecting)) {
        hasFiredRef.current = true;
        module.internals.bi.onBase44VoucherExposed == null || module.internals.bi.onBase44VoucherExposed({
          productId
        });
        observer.disconnect();
      }
    }, {
      threshold: 0.5
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [productId, module.internals.bi]);
};
//# sourceMappingURL=useBase44VoucherExposedBiEvent.js.map